'use strict';

/** @WebglMapStore */
var WebglMapStore = function WebglMapStore (ResourceHelper, Flux, TopControlsActions, APP_DISPATCHER_ID) {

  var DataCaptureStore = Flux.Store.get('DataCaptureStore'),

      WebglMapStore = Flux.Store.create({
        name: 'WebglMapStore',
        events: {
          Changed : true
        }
      });

  //null initial state
  WebglMapStore.$state = {
    currentDatacapture : null,
    active : false,
    pc_rgb: false,
    mesh_gltf: false
  };

  /**
   * Constructor function that binds to the interaction Flux.Action Signal from the component
   */
  WebglMapStore.init = function init () {
    var dispatcher = Flux.Dispatcher.get(APP_DISPATCHER_ID);

    dispatcher.register(TopControlsActions.ToggleWebglMap, this._handleToggleMap.bind(this));
  }.bind(this);

  this._handleToggleMap = function _handleToggleMap(ev) {
    var pc_rgb = ev.data === 'pc_rgb';
    var mesh_gltf = ev.data === 'mesh_gltf';
    angular.extend(WebglMapStore.$state, {
      currentDatacapture : ev.data ? DataCaptureStore.get('current') : null,
      active : ev.data,
      pc_rgb: pc_rgb,
      mesh_gltf: mesh_gltf
    });

    WebglMapStore.emit(WebglMapStore.Events.Changed);
  };

  this._handleDataCaptureStoreChange = function _handleDataCaptureStoreChange(ev) {
    if (WebglMapStore.get('active')){

      angular.extend(WebglMapStore.$state, {
        currentDatacapture:  DataCaptureStore.get('current'),
        active: false,
      });

      WebglMapStore.emit(WebglMapStore.Events.Changed);
    }
  };

  DataCaptureStore.on(DataCaptureStore.Events.Changed, this._handleDataCaptureStoreChange.bind(this));

  return WebglMapStore;
};

WebglMapStore.$inject = ['ResourceHelper', 'sbFlux', 'TopControlsActions', 'APP_DISPATCHER_ID'];
module.exports = WebglMapStore;



// WEBPACK FOOTER //
// ./src/app/dash/webglMap/WebglMapStore.js